// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* eslint:disable */
export const VERSION = {
    "version": "4.3.0",
    "short": "3f9886c",
    "branch": "Detached: 3f9886cf663be220629664f8d2982551e97c47e7",
    "date": "2026-5-1"
};
/* eslint:enable */
